import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToServices = () => {
    const section = document.getElementById('services');
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="hero">
      <div className="container">
        <div className="hero-content">
          <h1 className="hero-title">
            Welcome to <span className="brand">9kInfoTech</span>
          </h1>
          <p className="hero-subtitle">
            Your trusted partner for multi-platform mobile apps, websites, and software development
          </p>
          <p className="hero-description">
            We transform your ideas into powerful digital solutions with cutting-edge technology and innovative design
          </p>
          <div className="hero-buttons">
            <a href="#contact" className="btn btn-primary">Get Started</a>
            <a href="#projects" className="btn btn-secondary">View Our Work</a>
          </div>
        </div>
        <div className="hero-image">
          <div className="hero-graphic">
            <button
              type="button"
              className="floating-card card-1"
              onClick={scrollToServices}
            >
              <div className="card-icon">📱</div>
              <span>Mobile Apps</span>
            </button>
            <button
              type="button"
              className="floating-card card-2"
              onClick={scrollToServices}
            >
              <div className="card-icon">🌐</div>
              <span>Websites</span>
            </button>
            <button
              type="button"
              className="floating-card card-3"
              onClick={scrollToServices}
            >
              <div className="card-icon">💻</div>
              <span>Software</span>
            </button>
            <button
              type="button"
              className="floating-card card-4"
              onClick={scrollToServices}
            >
              <div className="card-icon">☁️</div>
              <span>Cloud Solutions</span>
            </button>
            <button
              type="button"
              className="floating-card card-5"
              onClick={scrollToServices}
            >
              <div className="card-icon">📈</div>
              <span>Digital Marketing</span>
            </button>
            <button
              type="button"
              className="floating-card card-6"
              onClick={scrollToServices}
            >
              <div className="card-icon">🤝</div>
              <span>Consulting</span>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
